const state = {
    initialIndicators: [],
    sections: {
        locked: {},
        indicatorsComplete: {}
    },
    savingIndicator: false,
    authUserRoles: [],
}

const getters = {
    //
}

const actions = {
    fetchInitialIndicators (context, data) {
        axios.get('/api/initial-indicators', {params: data})
        .then( (response) => {
            context.commit("setInitialIndicators", response.data)
            lockSections(context, response.data)
            completeSectionIndicators(context, response.data)
        })
        .catch( (e) => {
            console.log("Error: initial.js, fetchInitialIndicators(), "+ e.message)          
        })
    },
    saveInitialIndicator (context, data) {
        if (context.state.savingIndicator) {
            return
        }

        context.state.savingIndicator = true

        axios.post('/api/initial-indicator', data)
        .then((response) => {
            context.commit("setInitialIndicators", response.data)
            completeSectionIndicators(context, response.data)
        })
        .catch((e) => {
            console.log("Error: initial.js, saveIndicator(), "+ e.message)          
        })
        .finally(() => {
            context.state.savingIndicator = false
        })
    },
    lockIndicators (context, data) {
        axios.post('/api/initial-indicators-lock', data)
        .then((response) => {
            context.commit("setInitialIndicators", response.data)
            lockSections(context, response.data)
            
        })
        .catch((e) => {
            console.log("Error: initial.js, lockIndicators(), "+ e.message)          
        })
    },
    unlockIndicators (context, data) {
        axios.post('/api/initial-indicators-unlock', data)
        .then((response) => {
            context.commit("setInitialIndicators", response.data)
            lockSections(context, response.data)     
        })
        .catch((e) => {
            console.log("Error: initial.js, lockIndicators(), "+ e.message)          
        })
    },
    fetchAuthUserRoles (context) {
        axios.get("api/user-roles")
        .then((response) => {
            context.commit("setAuthUserRoles", response.data)
        })
        .catch((e) => {
            console.log("Error: initial.js, fetchAuthUserRoles()"+ e.message)          
        })
    }
}

const mutations = {
    setInitialIndicators (state, data) {
        return state.initialIndicators = data
    },
    setSectionLocked (state, data) {
        return state.sections.locked[data.section_number] = data.locked
    },
    setSectionIndicatorsComplete (state, data) {
        if (!state.sections.indicatorsComplete[data.section_number]) {
            state.sections.indicatorsComplete[data.section_number] = {}
        }
        return state.sections.indicatorsComplete[data.section_number][data.indicator_number] = data.grade
    },
    setAuthUserRoles (state, data) {
        return state.authUserRoles = data
    }
}

function lockSections (context, sections) {
    for (const [key, value] of Object.entries(sections)) {
        const valueKeys = Object.keys(value);
        const firstValueKey = valueKeys[0];
        if (value[firstValueKey] && value[firstValueKey]['locked_at']) {
            context.commit("setSectionLocked", {section_number: key, locked: true})
        } else {
            context.commit("setSectionLocked", {section_number: key, locked: false})
        }
    }
}

function completeSectionIndicators (context, sections) {
    for (const [key, value] of Object.entries(sections)) {
        let count = 0
        Object.values(value).forEach(val => {
            context.commit("setSectionIndicatorsComplete", {section_number: val.section_number, indicator_number: val.indicator_number, grade: val.grade})
        });
    } 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}